<div class="container limited">
  <div class="mb-6 mb-lg-9">
    <mwe-transparent-card>
      <div class="text-center">
        <p class="mb-2" translate="products-add.footer.newClient.info"></p>
        <mwe-button-link (clicked)="openOrderProductsPopup()" label="products-add.footer.newClient.link" color="blue" />
      </div>
    </mwe-transparent-card>
  </div>

  <mwe-headline headlineNodeType="h2" text="invoice-partialpayment-overview.faq.title" cssClass="mb-3 mb-lg-4" />
  <mwe-link-list-group [items]="items()" />
</div>
